module.exports = __webpack_public_path__ + "static/media/vlpartneri.4879e280.pdf";